(() => {
  const modal = document.querySelector('#interest-modal');

  document.querySelectorAll('[data-protected-video]').forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    if (!video) return;

    // Keep native download, picture-in-picture, and remote playback controls hidden.
    video.controls = false;
    video.setAttribute('controlslist', 'nodownload noplaybackrate');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('disableremoteplayback', '');
    video.setAttribute('x-webkit-airplay', 'deny');
    video.setAttribute('draggable', 'false');

    const blockMediaSave = (event) => event.preventDefault();
    [wrapper, video].forEach((element) => {
      element.addEventListener('contextmenu', blockMediaSave);
      element.addEventListener('dragstart', blockMediaSave);
    });

    // Keep the preview looping without asking Shopify for the less efficient
    // progressive MP4 source that its loop option requires.
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      video.play().catch(() => {});
    });

    // Pick the cheapest source the device can use before any byte is
    // fetched: HLS on Safari (adaptive), a 720p MP4 on compact screens,
    // full 1080p elsewhere. With preload="none" nothing downloads until
    // a src is assigned here.
    const pickSource = () => {
      if (video.src) return;
      const hls = video.dataset.hlsSource;
      const desktop = video.dataset.desktopSource;
      const mobile = video.dataset.mobileSource;
      const canHls = video.canPlayType('application/vnd.apple.mpegurl');
      if (canHls && hls) {
        video.src = hls;
      } else if (window.matchMedia('(max-width: 680px)').matches && mobile) {
        video.src = mobile;
      } else if (desktop || mobile) {
        video.src = desktop || mobile;
      }
    };

    const ensureLoaded = () => {
      pickSource();
      if (video.src && !video.dataset.loadStarted) {
        video.dataset.loadStarted = 'true';
        video.load();
      }
    };

    const startPreview = () => {
      ensureLoaded();
      video.play().catch(() => {});
    };

    if ('IntersectionObserver' in window) {
      const previewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startPreview();
          } else if (video.dataset.loadStarted) {
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 });
      previewObserver.observe(wrapper);
    } else {
      startPreview();
    }

    // Warm the cache during idle time so the preview starts instantly when
    // scrolled into view; skip on slow connections or when data saver is on.
    const warmUp = () => {
      if (video.dataset.loadStarted) return;
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && (connection.saveData || (connection.effectiveType && connection.effectiveType !== '4g'))) return;
      ensureLoaded();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(warmUp, { timeout: 4000 });
    } else {
      setTimeout(warmUp, 4000);
    }
  });

  const gallery = document.querySelector('[data-product-gallery]');

  if (gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const thumbnailsContainer = gallery.querySelector('[data-gallery-thumbnails]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const previousButton = gallery.querySelector('[data-gallery-previous]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-counter]');
    const imageButtons = [...gallery.querySelectorAll('[data-gallery-image]')];
    const total = slides.length;
    let activeIndex = 0;
    let scrollTimer = null;

    const scrollThumbnailIntoView = (thumbnail) => {
      if (!thumbnailsContainer || !thumbnail) return;
      const containerWidth = thumbnailsContainer.clientWidth;
      const thumbLeft = thumbnail.offsetLeft;
      const thumbWidth = thumbnail.offsetWidth;
      const targetScroll = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);
      thumbnailsContainer.scrollTo({
        left: Math.max(0, targetScroll),
        behavior: 'smooth',
      });
    };

    const updateGalleryState = (index) => {
      activeIndex = Math.max(0, Math.min(index, total - 1));

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('is-active', isActive);
        if (isActive) {
          thumbnail.setAttribute('aria-current', 'true');
          scrollThumbnailIntoView(thumbnail);
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });

      if (previousButton) {
        previousButton.disabled = activeIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = activeIndex === total - 1;
      }
      if (counter) {
        counter.textContent = `${activeIndex + 1} / ${total}`;
      }
    };

    const showSlide = (index) => {
      const nextIndex = Math.max(0, Math.min(index, total - 1));
      track.scrollTo({ left: nextIndex * track.clientWidth, behavior: 'smooth' });
      updateGalleryState(nextIndex);
    };

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        if (track.clientWidth) {
          updateGalleryState(Math.round(track.scrollLeft / track.clientWidth));
        }
      }, 80);
    }, { passive: true });

    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(activeIndex + 1);
      }
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        showSlide(Number(thumbnail.dataset.galleryIndex));
      });
    });

    if (previousButton) {
      previousButton.addEventListener('click', () => showSlide(activeIndex - 1));
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => showSlide(activeIndex + 1));
    }

    updateGalleryState(0);

    const lightbox = document.querySelector('[data-image-lightbox]');
    if (lightbox) {
      const lightboxImage = lightbox.querySelector('[data-lightbox-image]');
      const lightboxCounter = lightbox.querySelector('[data-lightbox-counter]');
      const lightboxPrevious = lightbox.querySelector('[data-lightbox-previous]');
      const lightboxNext = lightbox.querySelector('[data-lightbox-next]');
      const lightboxCloseButtons = lightbox.querySelectorAll('[data-lightbox-close]');
      let lastFocusedImage = null;

      const showLightboxImage = (index) => {
        const imageButton = imageButtons[index];
        const image = imageButton ? imageButton.querySelector('img') : null;
        if (!image) return;

        showSlide(index);
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt;
        lightboxCounter.textContent = `${index + 1} / ${total}`;
        lightboxPrevious.disabled = index === 0;
        lightboxNext.disabled = index === total - 1;
      };

      const openLightbox = (event) => {
        lastFocusedImage = event.currentTarget;
        showLightboxImage(Number(lastFocusedImage.dataset.galleryIndex));
        lightbox.hidden = false;
        document.body.classList.add('modal-open');
        lightbox.querySelector('[data-lightbox-close]').focus();
      };

      const closeLightbox = () => {
        lightbox.hidden = true;
        document.body.classList.remove('modal-open');
        if (lastFocusedImage) lastFocusedImage.focus();
      };

      imageButtons.forEach((button) => button.addEventListener('click', openLightbox));
      lightboxCloseButtons.forEach((button) => button.addEventListener('click', closeLightbox));
      lightboxPrevious.addEventListener('click', () => {
        if (activeIndex > 0) showLightboxImage(activeIndex - 1);
      });
      lightboxNext.addEventListener('click', () => {
        if (activeIndex < total - 1) showLightboxImage(activeIndex + 1);
      });

      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeLightbox();
        } else if (event.key === 'ArrowLeft' && activeIndex > 0) {
          showLightboxImage(activeIndex - 1);
        } else if (event.key === 'ArrowRight' && activeIndex < total - 1) {
          showLightboxImage(activeIndex + 1);
        }
      });
    }
  }

  if (!modal) {
    return;
  }

  const openButtons = document.querySelectorAll('[data-interest-open]');
  const closeButtons = modal.querySelectorAll('[data-interest-close]');
  const privacyOpenButtons = document.querySelectorAll('[data-privacy-open]');
  const form = modal.querySelector('#interest-form');
  const dialog = modal.querySelector('.interest-dialog');
  const formView = modal.querySelector('[data-form-view]');
  const privacyView = modal.querySelector('[data-privacy-view]');
  const privacyBack = modal.querySelector('[data-privacy-back]');
  let lastFocusedElement = null;
  let privacyReturnToForm = false;

  document.querySelectorAll('[data-brand-select]').forEach((brandSelect) => {
    const modelSelect = document.getElementById(brandSelect.dataset.brandSelect);
    if (!modelSelect) return;

    const placeholder = modelSelect.querySelector('[data-placeholder]');
    const modelOptions = [...modelSelect.querySelectorAll('option[data-brand]')].map((option) => option.cloneNode(true));
    const fallbackOption = modelSelect.querySelector('[data-fallback]');

    const updateModelOptions = () => {
      const selectedBrand = brandSelect.value;
      const nextPlaceholder = placeholder.cloneNode(true);
      nextPlaceholder.textContent = selectedBrand ? nextPlaceholder.dataset.readyText : nextPlaceholder.dataset.emptyText;
      const filteredOptions = modelOptions
        .filter((option) => option.dataset.brand === selectedBrand)
        .map((option) => option.cloneNode(true));
      modelSelect.replaceChildren(nextPlaceholder, ...filteredOptions, fallbackOption.cloneNode(true));
      modelSelect.disabled = !selectedBrand;
      modelSelect.required = Boolean(selectedBrand);
      modelSelect.value = '';
    };

    brandSelect.addEventListener('change', updateModelOptions);
    updateModelOptions();
  });

  const mountingSwitch = form ? form.querySelector('.mounting-switch') : null;
  const mountingTrack = mountingSwitch ? mountingSwitch.querySelector('.mounting-track') : null;
  const mountingOptions = mountingSwitch ? [...mountingSwitch.querySelectorAll('input[type="radio"]')] : [];

  if (mountingTrack && mountingOptions.length === 2) {
    mountingTrack.addEventListener('click', () => {
      const selectedIndex = mountingOptions.findIndex((option) => option.checked);
      mountingOptions[selectedIndex === 0 ? 1 : 0].checked = true;
    });
  }

  // Forced trade-off: at most two priorities may stay selected.
  const prioritiesGroup = form ? form.querySelector('[data-priorities-group]') : null;

  if (prioritiesGroup) {
    const priorityInputs = [...prioritiesGroup.querySelectorAll('[data-priority]')];
    const prioritiesStatus = prioritiesGroup.querySelector('[data-priorities-status]');
    const priorityLimit = Number(prioritiesGroup.dataset.prioritiesLimit) || 2;

    const updatePriorities = () => {
      const selected = priorityInputs.filter((input) => input.checked);
      const limitReached = selected.length >= priorityLimit;

      priorityInputs.forEach((input) => {
        input.disabled = limitReached && !input.checked;
      });

      prioritiesGroup.classList.toggle('is-limit-reached', limitReached);

      if (prioritiesStatus) {
        const template = prioritiesStatus.dataset.counterTemplate || '{{ count }}';
        const counterText = template.replace('[count]', String(selected.length));
        prioritiesStatus.textContent = limitReached
          ? `${counterText} · ${prioritiesStatus.dataset.limitNote || ''}`.trim()
          : counterText;
      }
    };

    priorityInputs.forEach((input) => input.addEventListener('change', updatePriorities));
    updatePriorities();
  }

  // Opting out of the product means no contact and no beta invite.
  const intentInputs = form ? [...form.querySelectorAll('input[name="contact[Intent]"]')] : [];
  const betaCheckbox = form ? form.querySelector('[data-beta-checkbox]') : null;
  const betaBlocks = form ? [...form.querySelectorAll('[data-beta-block]')] : [];
  const emailField = form ? form.querySelector('[data-email-field]') : null;
  const emailInput = form ? form.querySelector('#interest-email') : null;

  const isFeedbackOnly = () => intentInputs.some((input) => input.checked && input.dataset.intent === 'feedback');

  const syncIntentUi = () => {
    const feedbackOnly = isFeedbackOnly();

    if (emailInput) {
      emailInput.required = !feedbackOnly;
    }
    if (emailField) {
      emailField.hidden = feedbackOnly;
    }

    if (feedbackOnly && betaCheckbox) {
      betaCheckbox.checked = false;
    }
    betaBlocks.forEach((block) => {
      block.hidden = feedbackOnly;
    });
  };

  // Two-step form: the e-mail is stored as soon as step one is completed.
  const steps = form ? [...form.querySelectorAll('[data-form-step]')] : [];
  const progressSteps = form ? [...form.querySelectorAll('[data-progress-step]')] : [];
  const nextButton = form ? form.querySelector('[data-step-next]') : null;
  const backButton = form ? form.querySelector('[data-step-back]') : null;
  const stageField = form ? form.querySelector('[data-stage-field]') : null;
  let emailCaptured = false;

  const showStep = (stepNumber) => {
    steps.forEach((step) => {
      step.hidden = step.dataset.formStep !== String(stepNumber);
    });

    progressSteps.forEach((step) => {
      const stepIndex = Number(step.dataset.progressStep);
      const isActive = stepIndex === stepNumber;
      step.classList.toggle('is-active', isActive);
      step.classList.toggle('is-done', stepIndex < stepNumber);
      if (isActive) {
        step.setAttribute('aria-current', 'step');
      } else {
        step.removeAttribute('aria-current');
      }
    });

    if (dialog) {
      dialog.scrollTop = 0;
    }
  };

  const captureEmail = () => {
    if (!emailInput || emailCaptured || isFeedbackOnly()) return;

    const email = emailInput.value.trim();
    if (!email) return;

    const payload = new FormData();
    payload.append('form_type', 'contact');
    payload.append('utf8', '✓');
    payload.append('contact[email]', email);

    const selectedIntent = intentInputs.find((input) => input.checked);
    if (selectedIntent) {
      payload.append('contact[Intent]', selectedIntent.value);
    }
    payload.append('contact[Faze]', '1/2 – zachycen e-mail');

    emailCaptured = true;
    if (stageField) {
      stageField.value = '2/2 – dokončeno po zachycení e-mailu';
    }

    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: payload,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    }).catch(() => {
      emailCaptured = false;
      if (stageField) {
        stageField.value = 'Jednorázové odeslání (krok 1 se neuložil)';
      }
    });
  };

  intentInputs.forEach((input) => input.addEventListener('change', syncIntentUi));
  syncIntentUi();

  if (nextButton && steps.length > 1) {
    nextButton.addEventListener('click', () => {
      if (!isFeedbackOnly() && emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        emailInput.focus();
        return;
      }

      captureEmail();
      showStep(2);

      const stepTwo = steps.find((step) => step.dataset.formStep === '2');
      if (stepTwo) {
        window.requestAnimationFrame(() => stepTwo.focus());
      }
    });
  }

  if (backButton) {
    backButton.addEventListener('click', () => {
      showStep(1);
      if (emailInput) {
        window.requestAnimationFrame(() => emailInput.focus());
      }
    });
  }

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  const getFocusableElements = () => [...modal.querySelectorAll(focusableSelector)].filter((element) => !element.closest('[hidden]'));

  const setPrivacyVisible = (visible) => {
    if (!formView || !privacyView) {
      return;
    }

    formView.hidden = visible;
    privacyView.hidden = !visible;

    if (dialog) {
      if (visible) {
        dialog.setAttribute('aria-labelledby', 'privacy-title');
        dialog.setAttribute('aria-label', dialog.dataset.privacyLabel || '');
      } else {
        dialog.setAttribute('aria-labelledby', 'interest-title');
        dialog.setAttribute('aria-label', dialog.dataset.formLabel || '');
      }
    }

    if (privacyBack) {
      privacyBack.textContent = privacyReturnToForm
        ? privacyBack.dataset.formLabel
        : privacyBack.dataset.closeLabel;
    }

    if (dialog) {
      dialog.scrollTop = 0;
    }
  };

  const openModal = (event) => {
    if (event) {
      event.preventDefault();
      lastFocusedElement = event.currentTarget;
    }

    privacyReturnToForm = false;
    setPrivacyVisible(false);
    modal.hidden = false;
    document.body.classList.add('modal-open');

    const firstField = modal.querySelector('#interest-email') || getFocusableElements()[0];
    if (firstField) {
      window.requestAnimationFrame(() => firstField.focus());
    }
  };

  const closeModal = () => {
    modal.hidden = true;
    document.body.classList.remove('modal-open');
    privacyReturnToForm = false;
    setPrivacyVisible(false);
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  };

  const openPrivacy = (event) => {
    if (event) {
      event.preventDefault();
    }

    const modalWasOpen = !modal.hidden;
    privacyReturnToForm = modalWasOpen && formView && !formView.hidden;

    if (modal.hidden) {
      lastFocusedElement = event ? event.currentTarget : lastFocusedElement;
      modal.hidden = false;
      document.body.classList.add('modal-open');
    }

    setPrivacyVisible(true);

    const focusTarget = modal.querySelector('#privacy-title') || privacyBack;
    if (focusTarget) {
      window.requestAnimationFrame(() => focusTarget.focus());
    }
  };

  const closePrivacy = () => {
    if (privacyReturnToForm) {
      setPrivacyVisible(false);
      const privacyLink = formView ? formView.querySelector('[data-privacy-open]') : null;
      if (privacyLink) {
        window.requestAnimationFrame(() => privacyLink.focus());
      }
      return;
    }

    closeModal();
  };

  openButtons.forEach((button) => button.addEventListener('click', openModal));
  closeButtons.forEach((button) => button.addEventListener('click', closeModal));
  privacyOpenButtons.forEach((button) => button.addEventListener('click', openPrivacy));
  if (privacyBack) {
    privacyBack.addEventListener('click', closePrivacy);
  }

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) {
      return;
    }

    if (event.key === 'Escape') {
      if (privacyView && !privacyView.hidden) {
        closePrivacy();
        return;
      }

      closeModal();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusableElements = getFocusableElements();
    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  if (form) {
    form.addEventListener('submit', (event) => {
      const stepOne = steps.find((step) => step.dataset.formStep === '1');

      // Enter inside the e-mail field must advance to step two, never submit step two blind.
      if (stepOne && !stepOne.hidden && nextButton) {
        event.preventDefault();
        nextButton.click();
        return;
      }

      if (isFeedbackOnly() && emailInput) {
        emailInput.value = `miranabo.eshop+anonymni.${Date.now()}@gmail.com`;
        if (stageField) {
          stageField.value = 'Anonymni zpetna vazba (bez e-mailu)';
        }
      } else if (stepOne && emailInput && !emailInput.checkValidity()) {
        event.preventDefault();
        showStep(1);
        emailInput.reportValidity();
        emailInput.focus();
        return;
      }

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-sending');
        submitButton.textContent = submitButton.dataset.submittingLabel || 'Submitting…';
      }
    });
  }

  if (modal.querySelector('[data-form-success]')) {
    openModal();
  }

})();
